import { useEffect, useState } from "react";
import { RotateCw, Loader2 } from "lucide-react";
import "./sync-status.css";

function rel(iso) {
  if (!iso) return { text: "ποτέ", tone: "stale" };
  const ms = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(ms / 60000);
  const hours = ms / 3600000;
  let text;
  if (mins < 1) text = "μόλις τώρα";
  else if (mins < 60) text = `πριν ${mins} λεπτ${mins === 1 ? "ό" : "ά"}`;
  else if (hours < 24) { const h = Math.floor(hours); text = `πριν ${h} ώρ${h === 1 ? "α" : "ες"}`; }
  else { const d = Math.floor(hours / 24); text = `πριν ${d} μέρ${d === 1 ? "α" : "ες"}`; }
  const tone = hours < 6 ? "fresh" : hours < 24 ? "warn" : "stale";
  return { text, tone };
}

export function SyncStatus({ lastSync, onRefresh, canRefresh, busy, testid = "sync-status" }) {
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((n) => n + 1), 60000); return () => clearInterval(t); }, []);
  const { text, tone } = rel(lastSync);
  return (
    <div className={`sync-status sync-${tone}`} data-testid={testid}>
      <span className="sync-dot" />
      <span data-testid={`${testid}-label`}>Ενημερώθηκε {text}</span>
      {canRefresh && (
        <button type="button" className="sync-refresh" onClick={onRefresh} disabled={busy} data-testid={`${testid}-refresh`}>
          {busy ? <Loader2 size={13} className="sync-spin" /> : <RotateCw size={13} />}
          {busy ? "Ανανέωση…" : "Ανανέωση τώρα"}
        </button>
      )}
    </div>
  );
}
